// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: entry/payload/EntryPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { TournamentPayload } from "../../tournament/model/TournamentPt";
import { EntryGymPayload, EntryPayload, EntryPlayerPayload, EntrySummaryPayload } from "../model/EntryPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.entry.payload";

export interface EntryRegisterRequestPayload {
  /** 대회 고유 id */
  tournamentId: string;
  /** 체육관 정보 */
  gym:
    | EntryGymPayload
    | undefined;
  /** 신청 선수 목록 (이름 · 생년월일 · 성별이 모두 같은 선수는 중복으로 거른다) */
  player: EntryPlayerPayload[];
  /** 허위사실 기재 관련 동의 여부 (false 면 접수하지 않는다) */
  isFalseStatementAgreed: boolean;
  /** 신청 비밀번호 (조회 · 수정 · 취소에 쓴다. 해시로만 저장하고 어떤 응답에도 실리지 않는다) */
  password: string;
}

export interface EntryRegisterResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 발급된 신청번호 (예: "2026-000123") */
  entryNo: string;
}

/**
 * 체육관 본인 신청 목록 조회
 *
 * 신청번호를 몰라도 연락처 + 비밀번호로 자기 신청을 모두 찾을 수 있다.
 */
export interface EntryGetByGymRequestPayload {
  /** 체육관 연락처 */
  gymContactPhoneNo: string;
  /** 신청 비밀번호 */
  password: string;
}

export interface EntryGetByGymResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 신청 목록 (최근 접수 순) */
  data: EntrySummaryPayload[];
}

export interface EntryGetByEntryNoRequestPayload {
  /** 신청번호 */
  entryNo: string;
  /** 체육관 연락처 (인증이 없어 신청번호 · 비밀번호와 함께 일치해야 조회된다) */
  gymContactPhoneNo: string;
  /** 신청 비밀번호 */
  password: string;
}

export interface EntryGetByEntryNoResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 응답 */
  data:
    | EntryPayload
    | undefined;
  /** 신청이 속한 대회 (조회 화면에서 대회명 · 일정을 함께 보여준다) */
  tournament: TournamentPayload | undefined;
}

export interface EntryModifyRequestPayload {
  /** 신청번호 */
  entryNo: string;
  /** 체육관 연락처 (본인 확인용) */
  gymContactPhoneNo: string;
  /** 신청 비밀번호 (본인 확인용) */
  password: string;
  /** 체육관 정보 */
  gym:
    | EntryGymPayload
    | undefined;
  /** 신청 선수 목록 (부분 수정이 아니라 전체 교체다) */
  player: EntryPlayerPayload[];
}

export interface EntryCancelRequestPayload {
  /** 신청번호 */
  entryNo: string;
  /** 체육관 연락처 (본인 확인용) */
  gymContactPhoneNo: string;
  /** 신청 비밀번호 (본인 확인용) */
  password: string;
  /** 취소 사유 */
  reason: string;
}

function createBaseEntryRegisterRequestPayload(): EntryRegisterRequestPayload {
  return { tournamentId: "", gym: undefined, player: [], isFalseStatementAgreed: false, password: "" };
}

export const EntryRegisterRequestPayload: MessageFns<EntryRegisterRequestPayload> = {
  encode(message: EntryRegisterRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    if (message.gym !== undefined) {
      EntryGymPayload.encode(message.gym, writer.uint32(18).fork()).join();
    }
    for (const v of message.player) {
      EntryPlayerPayload.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.isFalseStatementAgreed !== false) {
      writer.uint32(32).bool(message.isFalseStatementAgreed);
    }
    if (message.password !== "") {
      writer.uint32(42).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryRegisterRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryRegisterRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gym = EntryGymPayload.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.player.push(EntryPlayerPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isFalseStatementAgreed = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryRegisterRequestPayload {
    return {
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      gym: isSet(object.gym) ? EntryGymPayload.fromJSON(object.gym) : undefined,
      player: globalThis.Array.isArray(object?.player)
        ? object.player.map((e: any) => EntryPlayerPayload.fromJSON(e))
        : [],
      isFalseStatementAgreed: isSet(object.isFalseStatementAgreed)
        ? globalThis.Boolean(object.isFalseStatementAgreed)
        : false,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: EntryRegisterRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.gym !== undefined) {
      obj.gym = EntryGymPayload.toJSON(message.gym);
    }
    if (message.player?.length) {
      obj.player = message.player.map((e) => EntryPlayerPayload.toJSON(e));
    }
    if (message.isFalseStatementAgreed !== false) {
      obj.isFalseStatementAgreed = message.isFalseStatementAgreed;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryRegisterRequestPayload>, I>>(base?: I): EntryRegisterRequestPayload {
    return EntryRegisterRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryRegisterRequestPayload>, I>>(object: I): EntryRegisterRequestPayload {
    const message = createBaseEntryRegisterRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    message.gym = (object.gym !== undefined && object.gym !== null)
      ? EntryGymPayload.fromPartial(object.gym)
      : undefined;
    message.player = object.player?.map((e) => EntryPlayerPayload.fromPartial(e)) || [];
    message.isFalseStatementAgreed = object.isFalseStatementAgreed ?? false;
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseEntryRegisterResponsePayload(): EntryRegisterResponsePayload {
  return { result: undefined, entryNo: "" };
}

export const EntryRegisterResponsePayload: MessageFns<EntryRegisterResponsePayload> = {
  encode(message: EntryRegisterResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.entryNo !== "") {
      writer.uint32(18).string(message.entryNo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryRegisterResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryRegisterResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryRegisterResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
    };
  },

  toJSON(message: EntryRegisterResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryRegisterResponsePayload>, I>>(base?: I): EntryRegisterResponsePayload {
    return EntryRegisterResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryRegisterResponsePayload>, I>>(object: I): EntryRegisterResponsePayload {
    const message = createBaseEntryRegisterResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.entryNo = object.entryNo ?? "";
    return message;
  },
};

function createBaseEntryGetByGymRequestPayload(): EntryGetByGymRequestPayload {
  return { gymContactPhoneNo: "", password: "" };
}

export const EntryGetByGymRequestPayload: MessageFns<EntryGetByGymRequestPayload> = {
  encode(message: EntryGetByGymRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gymContactPhoneNo !== "") {
      writer.uint32(10).string(message.gymContactPhoneNo);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGetByGymRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGetByGymRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.gymContactPhoneNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGetByGymRequestPayload {
    return {
      gymContactPhoneNo: isSet(object.gymContactPhoneNo) ? globalThis.String(object.gymContactPhoneNo) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: EntryGetByGymRequestPayload): unknown {
    const obj: any = {};
    if (message.gymContactPhoneNo !== "") {
      obj.gymContactPhoneNo = message.gymContactPhoneNo;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGetByGymRequestPayload>, I>>(base?: I): EntryGetByGymRequestPayload {
    return EntryGetByGymRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGetByGymRequestPayload>, I>>(object: I): EntryGetByGymRequestPayload {
    const message = createBaseEntryGetByGymRequestPayload();
    message.gymContactPhoneNo = object.gymContactPhoneNo ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseEntryGetByGymResponsePayload(): EntryGetByGymResponsePayload {
  return { result: undefined, data: [] };
}

export const EntryGetByGymResponsePayload: MessageFns<EntryGetByGymResponsePayload> = {
  encode(message: EntryGetByGymResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      EntrySummaryPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGetByGymResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGetByGymResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(EntrySummaryPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGetByGymResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => EntrySummaryPayload.fromJSON(e)) : [],
    };
  },

  toJSON(message: EntryGetByGymResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => EntrySummaryPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGetByGymResponsePayload>, I>>(base?: I): EntryGetByGymResponsePayload {
    return EntryGetByGymResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGetByGymResponsePayload>, I>>(object: I): EntryGetByGymResponsePayload {
    const message = createBaseEntryGetByGymResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => EntrySummaryPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntryGetByEntryNoRequestPayload(): EntryGetByEntryNoRequestPayload {
  return { entryNo: "", gymContactPhoneNo: "", password: "" };
}

export const EntryGetByEntryNoRequestPayload: MessageFns<EntryGetByEntryNoRequestPayload> = {
  encode(message: EntryGetByEntryNoRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entryNo !== "") {
      writer.uint32(10).string(message.entryNo);
    }
    if (message.gymContactPhoneNo !== "") {
      writer.uint32(18).string(message.gymContactPhoneNo);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGetByEntryNoRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGetByEntryNoRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gymContactPhoneNo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGetByEntryNoRequestPayload {
    return {
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
      gymContactPhoneNo: isSet(object.gymContactPhoneNo) ? globalThis.String(object.gymContactPhoneNo) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: EntryGetByEntryNoRequestPayload): unknown {
    const obj: any = {};
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    if (message.gymContactPhoneNo !== "") {
      obj.gymContactPhoneNo = message.gymContactPhoneNo;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGetByEntryNoRequestPayload>, I>>(base?: I): EntryGetByEntryNoRequestPayload {
    return EntryGetByEntryNoRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGetByEntryNoRequestPayload>, I>>(
    object: I,
  ): EntryGetByEntryNoRequestPayload {
    const message = createBaseEntryGetByEntryNoRequestPayload();
    message.entryNo = object.entryNo ?? "";
    message.gymContactPhoneNo = object.gymContactPhoneNo ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseEntryGetByEntryNoResponsePayload(): EntryGetByEntryNoResponsePayload {
  return { result: undefined, data: undefined, tournament: undefined };
}

export const EntryGetByEntryNoResponsePayload: MessageFns<EntryGetByEntryNoResponsePayload> = {
  encode(message: EntryGetByEntryNoResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.data !== undefined) {
      EntryPayload.encode(message.data, writer.uint32(18).fork()).join();
    }
    if (message.tournament !== undefined) {
      TournamentPayload.encode(message.tournament, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGetByEntryNoResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGetByEntryNoResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = EntryPayload.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tournament = TournamentPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGetByEntryNoResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: isSet(object.data) ? EntryPayload.fromJSON(object.data) : undefined,
      tournament: isSet(object.tournament) ? TournamentPayload.fromJSON(object.tournament) : undefined,
    };
  },

  toJSON(message: EntryGetByEntryNoResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data !== undefined) {
      obj.data = EntryPayload.toJSON(message.data);
    }
    if (message.tournament !== undefined) {
      obj.tournament = TournamentPayload.toJSON(message.tournament);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGetByEntryNoResponsePayload>, I>>(
    base?: I,
  ): EntryGetByEntryNoResponsePayload {
    return EntryGetByEntryNoResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGetByEntryNoResponsePayload>, I>>(
    object: I,
  ): EntryGetByEntryNoResponsePayload {
    const message = createBaseEntryGetByEntryNoResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? EntryPayload.fromPartial(object.data)
      : undefined;
    message.tournament = (object.tournament !== undefined && object.tournament !== null)
      ? TournamentPayload.fromPartial(object.tournament)
      : undefined;
    return message;
  },
};

function createBaseEntryModifyRequestPayload(): EntryModifyRequestPayload {
  return { entryNo: "", gymContactPhoneNo: "", password: "", gym: undefined, player: [] };
}

export const EntryModifyRequestPayload: MessageFns<EntryModifyRequestPayload> = {
  encode(message: EntryModifyRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entryNo !== "") {
      writer.uint32(10).string(message.entryNo);
    }
    if (message.gymContactPhoneNo !== "") {
      writer.uint32(18).string(message.gymContactPhoneNo);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    if (message.gym !== undefined) {
      EntryGymPayload.encode(message.gym, writer.uint32(34).fork()).join();
    }
    for (const v of message.player) {
      EntryPlayerPayload.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryModifyRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryModifyRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gymContactPhoneNo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.gym = EntryGymPayload.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.player.push(EntryPlayerPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryModifyRequestPayload {
    return {
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
      gymContactPhoneNo: isSet(object.gymContactPhoneNo) ? globalThis.String(object.gymContactPhoneNo) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      gym: isSet(object.gym) ? EntryGymPayload.fromJSON(object.gym) : undefined,
      player: globalThis.Array.isArray(object?.player)
        ? object.player.map((e: any) => EntryPlayerPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: EntryModifyRequestPayload): unknown {
    const obj: any = {};
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    if (message.gymContactPhoneNo !== "") {
      obj.gymContactPhoneNo = message.gymContactPhoneNo;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.gym !== undefined) {
      obj.gym = EntryGymPayload.toJSON(message.gym);
    }
    if (message.player?.length) {
      obj.player = message.player.map((e) => EntryPlayerPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryModifyRequestPayload>, I>>(base?: I): EntryModifyRequestPayload {
    return EntryModifyRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryModifyRequestPayload>, I>>(object: I): EntryModifyRequestPayload {
    const message = createBaseEntryModifyRequestPayload();
    message.entryNo = object.entryNo ?? "";
    message.gymContactPhoneNo = object.gymContactPhoneNo ?? "";
    message.password = object.password ?? "";
    message.gym = (object.gym !== undefined && object.gym !== null)
      ? EntryGymPayload.fromPartial(object.gym)
      : undefined;
    message.player = object.player?.map((e) => EntryPlayerPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntryCancelRequestPayload(): EntryCancelRequestPayload {
  return { entryNo: "", gymContactPhoneNo: "", password: "", reason: "" };
}

export const EntryCancelRequestPayload: MessageFns<EntryCancelRequestPayload> = {
  encode(message: EntryCancelRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entryNo !== "") {
      writer.uint32(10).string(message.entryNo);
    }
    if (message.gymContactPhoneNo !== "") {
      writer.uint32(18).string(message.gymContactPhoneNo);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    if (message.reason !== "") {
      writer.uint32(34).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryCancelRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryCancelRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entryNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gymContactPhoneNo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryCancelRequestPayload {
    return {
      entryNo: isSet(object.entryNo) ? globalThis.String(object.entryNo) : "",
      gymContactPhoneNo: isSet(object.gymContactPhoneNo) ? globalThis.String(object.gymContactPhoneNo) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: EntryCancelRequestPayload): unknown {
    const obj: any = {};
    if (message.entryNo !== "") {
      obj.entryNo = message.entryNo;
    }
    if (message.gymContactPhoneNo !== "") {
      obj.gymContactPhoneNo = message.gymContactPhoneNo;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryCancelRequestPayload>, I>>(base?: I): EntryCancelRequestPayload {
    return EntryCancelRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryCancelRequestPayload>, I>>(object: I): EntryCancelRequestPayload {
    const message = createBaseEntryCancelRequestPayload();
    message.entryNo = object.entryNo ?? "";
    message.gymContactPhoneNo = object.gymContactPhoneNo ?? "";
    message.password = object.password ?? "";
    message.reason = object.reason ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
